import { Avatar, Box, Flex, Icon, Text } from '@chakra-ui/react';
import { decode } from 'js-base64';
import { NotificationCard } from '../components/Card';
import { NotificationTime } from '../components/Time';
import { IntroRejected } from '@/assets/icons/notification';
import { NotificationLink } from '../components/NotificationLink';

export const IntroSkipped = ({ notification = {}, onClose = () => {} }) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));

  return (
    <NotificationCard notification={notification}>
      <Flex>
        <Box height="40px" pos="relative">
          <Avatar
            width="36px"
            height="36px"
            borderRadius="8px"
            className="avatar-md"
            name={data?.candidate_name}
            src={data?.contact_url} // image
          />
          <Box pos="absolute" bottom="-24px" left="9px">
            <Icon as={IntroRejected} width="40px" height="40px" />
          </Box>
        </Box>
        <Box ml="12px">
          <Text>
            <NotificationLink
              to={`/candidates/${data?.contact_id}`}
              label={data.candidate_name}
              onClose={onClose}
              notification={notification}
              data-test-id="candidate-profile-link"
            />
            has been removed from your intros to make. Someone else has already
            made an intro to this candidate.
          </Text>
          <NotificationTime notification={notification} />
        </Box>
      </Flex>
    </NotificationCard>
  );
};
